import { render, staticRenderFns } from "./ViewPaymentCard.vue?vue&type=template&id=6d272e2a&scoped=true"
import script from "./ViewPaymentCard.vue?vue&type=script&lang=js"
export * from "./ViewPaymentCard.vue?vue&type=script&lang=js"
import style0 from "./ViewPaymentCard.vue?vue&type=style&index=0&id=6d272e2a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d272e2a",
  null
  
)

export default component.exports